function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-receipt_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-receipt_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M11.375 15c.621 0 1.125-.504 1.125-1.125V6.093c0-.297-.12-.586-.33-.797L10.204 3.33A1.13 1.13 0 009.409 3H4.625A1.129 1.129 0 003.5 4.127v9.748c0 .621.504 1.125 1.125 1.125h6.75zm0-.75h-6.75a.376.376 0 01-.375-.375V4.127c0-.206.169-.377.375-.377H8.75v2.44c0 .31.25.56.562.56h2.437v7.125a.376.376 0 01-.375.375zm.364-8.248H9.5V3.764c.065.016.124.05.173.098l1.966 1.966c.05.05.082.108.099.174zm-1.227 2.764a.187.187 0 00.188-.188v-.375a.187.187 0 00-.188-.187H5.187A.187.187 0 005 8.203v.375c0 .104.084.188.188.188h5.324zm0 1.886a.187.187 0 00.188-.188v-.375a.187.187 0 00-.188-.187H5.187a.187.187 0 00-.187.187v.375c0 .104.084.188.188.188h5.324zm-.9 1.846a.187.187 0 00.188-.188v-.375a.187.187 0 00-.188-.187H5.188a.187.187 0 00-.187.187v.375c0 .104.084.188.188.188h4.425z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconReceiptinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgAtomsIconReceiptinline;